import React, {
  useEffect,
  useState,
  useCallback,
  useLayoutEffect,
} from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentHistory.scss";
import Loader from "../../../components/Loader/Loader";
import { toast } from "react-toastify";
import NoPayment from "./NoPayment";

function PaymentHistory({ scrollToTop }) {
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch upcoming bookings
  const fetchUpcomingBookings = useCallback(async () => {
    setLoading(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/memberships/get_all_payment_details`;
    const accessToken = window.localStorage.getItem("access_token");

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const data = await response.json();
      if (response.status === 200) {
        setPaymentHistory(data || []);
      } else if (response.status === 403) {
        window.localStorage.removeItem("access_token");
        window.localStorage.removeItem("flag");
        navigate("/login");
        window.location.reload();
      } else {
        // toast.error(data.detail || "Failed to fetch upcoming bookings.");
      }
    } catch (err) {
      // toast.error("An error occurred while fetching upcoming bookings.");
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  // Fetch data on component mount
  useEffect(() => {
    fetchUpcomingBookings();
  }, [fetchUpcomingBookings]);

  // Set document title and scroll to top
  useEffect(() => {
    document.title = `Upcoming Bookings | Ballers`;
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleBack = () => {
    navigate(-1); // Navigate back to the previous page
  };
  // useLayoutEffect(() => {
  //   if (!loading) {
  //     // Scroll the inner container
  //     const el = document.getElementById("scrollable-container");
  //     // Scroll the entire window first
  //     window.scrollTo({ top: 0, behavior: "smooth" });

  //     setTimeout(() => {
  //       if (el) {
  //         el.scrollTo({ top: 0, behavior: "smooth" });
  //       }
  //     }, 100);
  //   }
  // }, [loading]);
  useLayoutEffect(() => {
    if (!loading && scrollToTop) {
      scrollToTop();
    }
  }, [loading, scrollToTop]);
  return (
    <div className="payment-history" id="scrollable-container">
      <div className="header-container">
        <span className="back-icon" onClick={handleBack}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#FFB000"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </span>
        <h2 className="section-title">PAYMENTS</h2>
      </div>
      <div className="payment-container">
        {loading ? (
          <Loader />
        ) : paymentHistory.length > 0 ? (
          <>
            <div className="payment-table-wrapper">
              <table className="payment-table">
                <thead>
                  <tr>
                    <th>ORDER ID</th>
                    <th>DATE</th>
                    <th>AMOUNT</th>
                    <th>STATUS</th>
                    <th>DESCRIPTION</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.map((payment, index) => (
                    <tr key={index}>
                      <td>{payment.order_id}</td>
                      <td>{payment.date}</td>
                      <td>₹ {payment.amount}</td>
                      <td>
                        <span
                          className={`statusPayment ${payment.status.toLowerCase()}`}
                        >
                          {payment.status.charAt(0).toUpperCase() +
                            payment.status.slice(1)}
                        </span>
                      </td>
                      <td>{payment.source}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="payment-list">
              {paymentHistory.map((payment, index) => (
                <div className="payment-card" key={index}>
                  <div className="payment-detail">
                    <span className="label">ORDER ID:</span>
                    <span className="value">{payment.order_id}</span>
                  </div>
                  <div className="payment-detail">
                    <span className="label">DATE:</span>
                    <span className="value">{payment.date}</span>
                  </div>
                  <div className="payment-detail">
                    <span className="label">AMOUNT:</span>
                    <span className="value" style={{ color: "#FFB000" }}>
                      ₹ {payment.amount}
                    </span>
                  </div>
                  <div className="payment-detail">
                    <span className="label">STATUS:</span>
                    <span
                      className={`value statusPayment ${payment.status.toLowerCase()}`}
                    >
                      {payment.status.charAt(0).toUpperCase() +
                        payment.status.slice(1)}
                    </span>
                  </div>
                  <div className="payment-detail">
                    <span className="label">DESCRIPTION:</span>
                    <span className="value">{payment.source}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <NoPayment />
        )}
      </div>
    </div>
  );
}

export default PaymentHistory;
